import styled from 'styled-components';

import { ANIM, LOGIN } from '../../../../theme/tokens';

/**
 * Hover anchor around the auth CTA.
 *
 * A natively `disabled` button fires no pointer events at all, and this one also
 * carries `pointer-events: none`, so it can never be hovered itself and the tip has
 * to hang off an ancestor. The anchor is that ancestor: hovering the button's area
 * lands on this element instead (verified: `elementFromPoint` over the disabled CTA
 * resolves to its wrapper), which is what reveals the tip in pure CSS, with no
 * listeners and no state.
 *
 * It wraps ONLY the button, not the whole `.cta`, on /register that container also
 * holds the "No credit card required" note, and anchoring there would pop the tip
 * when the cursor is nowhere near the button.
 *
 * `width: 100%` is load-bearing: /login's `.cta` is a centred column flex, so an
 * intrinsically-sized wrapper would shrink-to-fit and the button's own `width: 100%`
 * would collapse with it.
 */
export const Anchor = styled.div`
  position: relative;
  width: 100%;
  display: flex;
`;

/**
 * The tip itself: same floating material as the language popover on these screens
 * (see the `tip*` tokens), sitting above the CTA and centred on it.
 */
export const Tip = styled.span`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  z-index: 2;
  /* The tip must never take the pointer. It covers the very area that reveals it, so
     a hoverable tip would fight its own anchor and flicker. */
  pointer-events: none;
  padding: 8px 12px;
  border-radius: 11px;
  background: ${LOGIN.tipBg};
  border: 1px solid ${LOGIN.tipBorder};
  box-shadow: ${LOGIN.tipShadow};
  color: ${LOGIN.tipText};
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
  opacity: 0;
  transform: translate(-50%, 4px);
  transition:
    opacity ${ANIM.INTERACT_MS}ms ${ANIM.EASE},
    transform ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  ${Anchor}:hover & {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
